import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";

type WelcomeContextValue = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
};

const WelcomeContext = createContext<WelcomeContextValue | undefined>(
  undefined
);

export const WelcomeProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(() => {
    return false;
    try {
      return localStorage.getItem("hasSeenWelcome") !== "true";
    } catch {
      return true;
    }
  });

  const close = useCallback(() => {
    setIsOpen(false);
    try {
      localStorage.setItem("hasSeenWelcome", "true");
    } catch {}
  }, []);

  const open = useCallback(() => {
    setIsOpen(true);
    try {
      localStorage.removeItem("hasSeenWelcome");
    } catch {}
  }, []);

  const toggle = useCallback(() => {
    setIsOpen((prev) => {
      const next = !prev;
      try {
        if (!next) {
          localStorage.setItem("hasSeenWelcome", "true");
        } else {
          localStorage.removeItem("hasSeenWelcome");
        }
      } catch {}
      return next;
    });
  }, []);

  const value = useMemo(
    () => ({ isOpen, open, close, toggle }),
    [isOpen, open, close, toggle]
  );

  return (
    <WelcomeContext.Provider value={value}>{children}</WelcomeContext.Provider>
  );
};

export const useWelcome = (): WelcomeContextValue => {
  const ctx = useContext(WelcomeContext);
  if (!ctx) {
    throw new Error("useWelcome deve essere usato dentro WelcomeProvider");
  }
  return ctx;
};
